import React from 'react';
import type PlanSettingsProgramBoardsType from '@atlassian/jira-spa-apps-advanced-roadmaps-plan/src/ui/plan-settings/program-boards/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

/**
 * Plan Settings - removed-issues page
 */
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyPlanSettingsProgramBoards = lazyForPaint<typeof PlanSettingsProgramBoardsType>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-plan-settings-program-boards", jiraSpaEntry: "async-plan-settings-program-boards" */ '@atlassian/jira-spa-apps-advanced-roadmaps-plan/src/ui/plan-settings/program-boards'
			),
		),
	{ ssr: false },
);

const AsyncPlanSettingsProgramBoards = (): React.JSX.Element => (
	<LazyPage
		Page={LazyPlanSettingsProgramBoards}
		pageId="plan-settings-program-boards"
		shouldShowSpinner
	/>
);

export default AsyncPlanSettingsProgramBoards;
